import { MessagesSquare, PenTool, Cpu, Rocket } from "lucide-react";
import { Reveal, SectionHeading } from "./Reveal";
import { PROCESS } from "../config/site";

const ICONS = [MessagesSquare, PenTool, Cpu, Rocket];

export default function Process() {
  return (
    <section
      id="process"
      className="relative scroll-mt-24 border-t border-white/[0.05] bg-[#07080f] py-24 sm:py-28"
      data-testid="process-section"
    >
      <div
        className="pointer-events-none absolute left-1/2 top-1/2 h-[400px] w-[700px] -translate-x-1/2 -translate-y-1/2 rounded-full bg-indigo-600/[0.07] blur-[130px]"
        aria-hidden="true"
      />
      <div className="relative mx-auto max-w-5xl px-5 sm:px-8">
        <SectionHeading
          eyebrow="How It Works"
          title={
            <>
              From Idea to Live Website — <span className="text-gradient">in 4 Steps</span>
            </>
          }
        />

        <div className="mt-16">
          {PROCESS.map((p, i) => {
            const Icon = ICONS[i];
            return (
              <Reveal key={p.num} delay={0.05 * i}>
                <div
                  className={`group relative flex flex-col gap-5 border-t border-white/[0.08] py-10 transition-colors duration-500 hover:border-indigo-400/40 sm:flex-row sm:items-center sm:gap-12 ${
                    i === PROCESS.length - 1 ? "border-b" : ""
                  }`}
                  data-testid={`process-step-${i + 1}`}
                >
                  <span
                    className="stroke-num font-display text-6xl font-extrabold leading-none transition-all duration-500 group-hover:[-webkit-text-stroke-color:rgba(129,140,248,0.65)] sm:text-8xl sm:min-w-[180px]"
                    aria-hidden="true"
                  >
                    {p.num}
                  </span>
                  <div className="flex-1">
                    <h3 className="flex items-center gap-3 font-display text-2xl font-bold text-white sm:text-3xl">
                      {p.title}
                      <Icon className="h-5 w-5 text-indigo-400/80" />
                    </h3>
                    <p className="mt-2.5 max-w-xl text-[15px] leading-relaxed text-slate-400">
                      {p.desc}
                    </p>
                  </div>
                  <span className="font-mono text-[10px] uppercase tracking-[0.3em] text-slate-600 transition-colors duration-500 group-hover:text-indigo-300">
                    Step {i + 1} / 4
                  </span>
                </div>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
}
